import React from 'react';
import { Microphone, XCircle } from '@phosphor-icons/react';
import { Button, Spinner, Text } from '@radix-ui/themes';
import { useMediaQuery } from '../shared-functions';

const AudioRecorder = ({ isRecording, volumeLevel, onStart, onStop, isConnecting }) => {
  
  const isPageWide = useMediaQuery('(min-width: 960px)');

  if (!isRecording && !isConnecting) {
    return (
      <Button variant="solid" color="red" size={isPageWide ? '4' : '3'} onClick={() => onStart()}>
        <Microphone size={20} color="#fff" weight="bold" /> Start
      </Button>
    )
  }

  if (isConnecting) {
    return (
      <Button variant="solid" color="red" size={isPageWide ? '4' : '3'} disabled>
        <Spinner size="2" /> Connecting...
      </Button>
    )
  }

  if (isRecording) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
        <div style={{ width: 36, height: 36 }} />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'transparent', transform: `scale(${1 + volumeLevel * 0.3})`, transition: 'transform 0.1s linear' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <span style={{ width: 2, height: `${3 + volumeLevel * 5}px`, background: '#000', borderRadius: '2px' }} />
            <span style={{ width: 2, height: `${10 + volumeLevel * 10}px`, background: '#000', borderRadius: '2px' }} />
            <span style={{ width: 2, height: `${4 + volumeLevel * 3}px`, background: '#000', borderRadius: '2px' }} />
            <span style={{ width: 2, height: `${8 + volumeLevel * 7}px`, background: '#000', borderRadius: '2px' }} />
            <span style={{ width: 2, height: `${6 + volumeLevel * 4}px`, background: '#000', borderRadius: '2px' }} />
          </div>
        </div>
        <XCircle size={36} weight="fill" onClick={() => onStop()} style={{ cursor: 'pointer', color: '#999999', zIndex: 2 }} />
      </div>
    )
  }

};

export default AudioRecorder;